import PropTypes from 'prop-types';

import { Helmet, HelmetProvider } from 'react-helmet-async';
import { CssBaseline, ThemeProvider } from '@mui/material';
import patientTheme from './patientTheme';
import React from 'react';

export const WithPatientTheme = props => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={patientTheme}>
        {/*
                We don't want search engines to index our survey pages.
                https://searchfacts.com/robots-txt-allow-disallow-all/
             */}
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <style type="text/css">
            {`
                    html {
                      overscroll-behavior: none;
                    }
                `}
          </style>
        </Helmet>

        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </HelmetProvider>
  );
};
WithPatientTheme.propTypes = {
  props: PropTypes.object,
};
